module.exports = __webpack_public_path__ + "img/upload.8a0e53e6.png";